module.exports = __webpack_public_path__ + "static/img/full1.dd3beb4f.svg";